export const getSymbolPathname = (symbol: string, isSpot?: boolean) => {
  return `/trade/${isSpot ? 'spot' : 'perpetual'}/${symbol}`;
};
